import { useRef } from 'react';
import { AutosizeInput, Chip, ChipValue, Size } from '@optimus-web/core';
import { ValueContainerElement } from './style';

export interface ChipsProps {
    value: string;
    size?: Size;
    chips: string[];
    invalidChips?: string[];
    handleRemoveChip: (event: React.SyntheticEvent, value: ChipValue) => void;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const Chips = ({
    size = 'small',
    chips,
    invalidChips,
    value,
    handleRemoveChip,
    handleChange,
    handleKeyDown,
    onBlur,
    onFocus,
}: ChipsProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleClick = () => inputRef.current?.focus();

    return (
        <ValueContainerElement size={size} onClick={handleClick}>
            {chips.map((chip) => (
                <Chip
                    value={chip}
                    onRemove={handleRemoveChip}
                    error={invalidChips?.includes(chip)}
                    key={chip}
                    cancelEvent={false}
                >
                    {chip}
                </Chip>
            ))}
            <AutosizeInput
                ref={inputRef}
                inputSize={size}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onBlur={onBlur}
                onFocus={onFocus}
            />
        </ValueContainerElement>
    );
};
